import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import EditablePictureContainer from '~components/generic/editable-picture/EditablePictureContainer';
import { Link } from '~components/generic/elements/Link/Link';
import { ModuleAttachments } from '~components/generic/module-attachments/ModuleAttachments';
import { IEntityComponentProps } from '~interfaces/props';
import { getFieldValue, getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import { imageProportions } from '~services/responsive-helpers';

export const ModuleTextImage = ({
  data,
  uploadFileAction,
  editing,
  className,
  onChange,
  entityDef,
  isEditing,
}: IEntityComponentProps) => {
  if (!data) {
    return null;
  }

  const imageSize = data.attributes.field_image_size ?? 2;
  const imagePos = data.attributes.field_image_pos ?? 1;
  const imageProportionKey = data.attributes.field_image_proportions ?? 1;
  const imageId = getRelatedEntityIds(data, 'field_image')[0];
  const externalLink: string = data.attributes.field_link_external?.uri || null;
  const internalLink: string = data.attributes.field_link_internal || null;
  const showBorder = Boolean(data.attributes.field_show_border);
  const borderRadius = parseInt(data.attributes.field_border_radius || '0', 10);
  const showOriginal = data.attributes.field_image_proportions === 5;

  const clsModule = clsx({ ...className.module });
  const clsContainer = clsx({ ...className.container });
  const clsImageColumn = clsx('col u-margin-top-md col-12 c-module--type--text-image', {
    'col-md-6': imageSize === 2,
    'col-md-4': imageSize === 1,
  });
  const clsTextColumn = clsx('o-field-text col u-margin-top-md col-12 order-1', {
    'col-md-6': imageSize === 2,
    'col-md-8': imageSize === 1,
    'order-md-0': imagePos === 2,
  });

  return (
    <div className={clsModule} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={clsContainer}>
        <div className="row c-module__header">
          <div className="col col-12">
            <EditableField
              hide={data.attributes.field_hide_title}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={data.attributes.field_title.value}
              editing={editing}
              onChange={onChange}
            />
          </div>
          <ModuleAttachments data={data} />
        </div>
        <div className="flex-wrap row c-module__content">
          <div className={clsTextColumn}>
            <EditableField
              entityType={data.type}
              fieldName="attributes.field_text.value"
              data={data.attributes.field_text && data.attributes.field_text.value}
              editing={editing}
              onChange={onChange}
            />
            {(internalLink || externalLink) && (
              <Link
                label={getFieldValue<string>(data, 'attributes.field_link_text')}
                url={externalLink}
                id={internalLink}
              />
            )}
          </div>
          <div className={clsImageColumn}>
            <EditablePictureContainer
              showWhenEmpty={true}
              entityType={data.type}
              fieldName="relationships.field_image"
              entityId={imageId}
              editing={editing}
              proportions={imageProportions[imageProportionKey]}
              onChangeImage={onChange}
              onUpload={uploadFileAction}
              placeholder={isEditing && entityDef.fields['relationships.field_image'].options.placeholder}
              border={showBorder}
              borderRadius={borderRadius}
              showOriginal={showOriginal}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleTextImage;
